import type { ReactNode } from "react";
import { QueryProvider } from "@/app/QueryProvider";
import { NativeImpersonationBootstrap } from "./native/NativeImpersonationBootstrap";
import { NativeMetaBootstrap } from "./native/NativeMetaBootstrap";
import { PullToRefreshProvider } from "@/shared/pull-to-refresh";

export function AppProviders({ children }: { children: ReactNode }) {
  return (
    <QueryProvider bootstrap={<><NativeImpersonationBootstrap /><NativeMetaBootstrap /></>}>
      <PullToRefreshProvider>{children}</PullToRefreshProvider>
    </QueryProvider>
  );
}
